import { createCRUDHook } from './createCRUDHook';
import { PartComponentDto } from 'utils/models';
import {
  PART_COMPONENT,
  GET_FILTERED_PART_COMPONENT,
  CAN_ADD_SUB_PART,
} from './apiEndPoints';
import { FilterOptionModel } from 'utils/models';
import { prepareQueryParams } from 'utils';

interface PartComponentCustomOperations {
  getFilteredPartComponentData: (
    filteredEntities: FilterOptionModel
  ) => Promise<PartComponentDto[]>;
  CanAddSubPart: (mainPartId: number, subPartId: number) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  PartComponentDto,
  PartComponentDto[],
  PartComponentCustomOperations
>({
  entityName: 'PartComponent',
  endpoint: PART_COMPONENT,

  customOperations: (auth) => ({
    getFilteredPartComponentData: async (
      filteredEntities: FilterOptionModel
    ): Promise<PartComponentDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          PART_COMPONENT +
            GET_FILTERED_PART_COMPONENT +
            `?${prepareQueryParams(filteredEntities)}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    CanAddSubPart: async (
      mainPartId: number,
      subPartId: number
    ): Promise<boolean> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          PART_COMPONENT +
            CAN_ADD_SUB_PART +
            `?mainPartId=${mainPartId}&subPartId=${subPartId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const PartComponentContext = Context;
export const usePartComponentManager = useManager;
export const usePartComponent = useConsumer;
